import { CardImageSection } from '@quicktools/shared-components';
import { CardImageMediaTypes } from '@quicktools/shared-components/components/landingPages/base/CardImage/types';
import { useTranslation } from 'react-i18next';

function WhySection() {
  const { t } = useTranslation();

  const cardImages = [
    {
      src: 'https://cdn140.picsart.com/19590691180895739109.svg',
    },
    {
      src: 'https://cdn140.picsart.com/44196028685084740523.svg',
    },
    {
      src: 'https://cdn140.picsart.com/67684046627063369020.svg',
    },
  ];

  const cards = cardImages.map(({ src }, index) => ({
    title: t(`home.whySection.cards.${index}.title`),
    description: t(`home.whySection.cards.${index}.description`),
    media: {
      type: CardImageMediaTypes.Image,
      images: [{ src, alt: t(`home.whySection.cards.${index}.title`) }],
    },
  }));

  return <CardImageSection title={t('home.whySection.title')} items={cards} />;
}

export default WhySection;
